export default {"src":"/_next/static/media/notifications-icon.b2a6a025.svg","height":18,"width":17};